import { useEffect, useState, useCallback } from "react";
import Button from "../../Components/Button";
import Header from "../../Components/Header";
import { useNavigate } from "react-router-dom";
import { LOW_END_EVENT_INFO } from "../../Router/path";
import axios from "axios";
import { LE_EVENT_LIST_API, LE_CREATE_EVENT_API } from "../../Constant/api";
import { useToast } from "../../Components/Toast";
import LoadingInComponent from "../../Components/LoadingInComponent";
import Paginator from "../../Components/Paginator";
import Modal from "../../Components/Modal";
import TextboxSet from "../../Components/TextboxSet";
import LocationSet from "../../Components/LocationSet";

const LEEventList = () => {
  const [loading, setLoading] = useState(false);
  const [eventList, setEventList] = useState(null);
  const [eventListMeta, setEventListMeta] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [eventForm, setEventForm] = useState({
    name: "",
    venue: "",
    date: "",
    time: "",
  });

  const navigate = useNavigate();

  const { toast } = useToast();

  const fetchEventList = useCallback((page = 1) => {
    setLoading(true);
    axios
      .get(LE_EVENT_LIST_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: { page: page },
      })
      .then((response) => {
        setEventList(response.data.data);
        setEventListMeta(response.data.meta.pagination);
        setLoading(false);
      })
      .catch((error) => {
        toast(
          error.response?.data?.message || "Failed to fetch event list",
          "error",
        );
        console.error("Error fetching event list:", error);
        setLoading(false);
      });
  }, [toast]);

  const handleOnChange = (e) => {
    setEventForm({ ...eventForm, [e.target.name]: e.target.value });
  };

  const createEvent = () => {
    axios
      .post(LE_CREATE_EVENT_API, eventForm, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
      })
      .then((response) => {
        toast("Event created successfully", "success");
        setShowModal(false);
        setEventForm({
          name: "",
          venue: "",
          date: "",
          time: "",
        });
        fetchEventList();
      })
      .catch((error) => {
        toast(
          error.response?.data?.message || "Failed to create event",
          "error",
        );
        console.error("Error creating event:", error);
      });
  };

  const handlePageClick = (page) => {
    fetchEventList(page);
  };

  useEffect(() => {
    if (!eventList) {
      fetchEventList();
    }
  }, [eventList, fetchEventList]);

  return (
    <div className="flex flex-col w-full min-h-screen">
      <Header noSidebar={true} />

      {showModal && (
        <Modal
          title="Create Event"
          toggleModal={() => {
            setEventForm({
              name: "",
              venue: "",
              date: "",
              time: "",
            });
            setShowModal(!showModal);
          }}
          handleSubmit={createEvent}
          submitLabel="Create"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 w-full h-full gap-[24px]">
            <TextboxSet
              onChange={handleOnChange}
              value={eventForm.name}
              type="text"
              label="Event Title"
              placeholder="Event Title"
              name="name"
              required
            />
            <LocationSet
              onChange={handleOnChange}
              value={eventForm.venue}
              name="venue"
              placeholder="Venue"
            />
            <TextboxSet
              onChange={handleOnChange}
              type="date"
              label="Date"
              name="date"
              value={eventForm.date}
            />
            <TextboxSet
              onChange={handleOnChange}
              type="time"
              label="Time"
              name="time"
              value={eventForm.time}
            />
          </div>
        </Modal>
      )}

      <div className="flex flex-col w-full h-fit min-h-[calc(70%)] lg:px-[128px] items-center p-[16px] md:p-[32px] gap-[16px] md:gap-[32px] bg-[#F7F8F9]">
        <div className="flex w-full justify-between">
          <h1 className="text-[29px]">Your Event</h1>

          <Button
            variant="primary"
            onClick={() => setShowModal(!showModal)}
            disabled={loading}
          >
            Create Event
          </Button>
        </div>
        <LoadingInComponent isLoading={loading}>
          <div className="flex flex-col w-full h-full gap-[16px]">
            {eventList && eventList.length > 0 ? (
              <div className="flex flex-col gap-4">
                {eventList.map((event, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      sessionStorage.setItem("event_id", event.id);
                      navigate(LOW_END_EVENT_INFO);
                    }}
                    className="grid grid-cols-1 md:grid-cols-2 bg-white p-[16px] rounded-lg border border-[#EFF0F2] hover:border-[hsl(0,0%,57%)] cursor-pointer"
                  >
                    <h2 className="text-[20px] font-semibold">{event.name}</h2>
                    <p className="text-[14px] text-[#666666] md:text-end">
                      {event.date ?? "No Date Set"}
                    </p>
                    <p className="text-[14px] text-[#666666]">
                      {event.venue ?? "No Venue Set"}
                    </p>
                    <p className="text-[14px] text-[#666666] md:text-end">
                      {event.time ?? "No Time Set"}
                    </p>
                  </div>
                ))}
                <Paginator
                  handlePageClick={handlePageClick}
                  meta={eventListMeta}
                  // perPage={perPage}
                  // handlePerPageChange={handlePerPageChange}
                />
              </div>
            ) : (
              <div className="flex flex-col w-full h-full items-center justify-center">
                <p className="text-[16px] text-[#666666] text-center">
                  You have no events yet. Click "Create Event" to get started!
                </p>
              </div>
            )}
          </div>
        </LoadingInComponent>
      </div>
    </div>
  );
};

export default LEEventList;
